import { Route, Routes, Navigate, Outlet } from 'react-router-dom'
import ProtectedRoute from './ProtectedRoute'
import { ScopedRoute } from './components/routing/ScopedRoute'
import Login from './pages/Login'
import Signup from './pages/Signup'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import AdminHomePage from './pages/AdminHomePage'
import Demo from './pages/Demo'
import UserRolesPage from './pages/userRoles/page'
import UsersPage from './pages/users/page'
import ClinicsPage from './pages/clinics/page'
import ClinicPage from './pages/clinic/page'
import ClinicHomePage from './pages/clinic/home/page'
import SystemVersionsPage from './pages/systemVerions/page'
import AdSuppliersPage from './pages/adSuppliers/page'
import AdSupplierPage from './pages/adSupplier/page'
import ClinicUsers from './pages/clinic/ClinicUsers'
import ExaminationRoomsPage from './pages/clinic/examinationRooms/page'
import AdSupplierUsersPage from './pages/adSupplier/adSupplierUsers/page'
import AdSupplierAdsPage from './pages/adSupplier/adSupplierAds/page'
import AdSupplierAdImagesPage from './pages/adSupplier/adImages/page'
import AdSupplierBrandsPage from './pages/adSupplier/brands/page'
import AdSupplierClinicsPage from './pages/adSupplier/clinics/page'
import AdSupplierReportsPage from './pages/adSupplier/reports/page'
import SupplierAdSchedulesPage from './pages/adSupplier/adSchedules/page'
import SupplierAdScheduleViewPage from './pages/adSupplier/adSchedules/ViewTemplatePage'
import BroadcastDevicesPage from './pages/clinic/broadcastDevices/page'
import ModulesPage from './pages/clinic/modules/page'
import DoctorsPage from './pages/clinic/doctors/page'
import QueueMachinesPage from './pages/clinic/queueMachines/page'
import IntegrationVendorsPage from './pages/integrationVendors/page'
import WarRoomPage from './pages/warRoom/page'
import AdScheduleTemplatePage from './pages/adScheduleTemplate/page'
import ViewTemplatePage from './pages/adScheduleTemplate/ViewTemplatePage'
import EditTemplatePage from './pages/adScheduleTemplate/EditTemplatePage'
import ApplyTemplatePage from './pages/adScheduleTemplate/ApplyTemplatePage'
import AdImageBatchPage from './pages/adImageBatch/page'
import EditAdImageBatchPage from './pages/adImageBatch/EditBatchPage'
import ApplyAdImageBatchPage from './pages/adImageBatch/ApplyBatchPage'
import DeviceManagementPage from './pages/deviceManagement/page'
import InvestorClinicsPage from './pages/investor/clinics/page'
import AuditLogsPage from './pages/auditLogs/page'
import ChangePassword from './pages/settings/ChangePassword'
import Account from './pages/settings/Account'
import ProvidersPage from './pages/providers/page'
import ProviderPage from './pages/provider/page'
import ProviderUsersPage from './pages/provider/providerUsers/page'
import ClinicUserRolesPage from './pages/clinic/userRoles/page'
import SupplierUserRolesPage from './pages/adSupplier/userRoles/page'
import ToolkitPage from './pages/apps/toolkit/page'
import CreateAllClinicUserRolePage from './pages/apps/createAllClinicUserRole/page'
import ProviderClinicUsersPage from './pages/apps/providerClinicUsers/page'
import AnnouncementsPage from './pages/apps/announcements/page'
import TvTemplatesPage from './pages/apps/tvTemplates/page'
import TvTemplateDetailPage from './pages/apps/tvTemplates/detail'
import TagManagementPage from './pages/apps/tagManagement/page'
import ConnectionStatusSnapshotsPage from './pages/connectionStatusSnapshots/page'
import SystemToolsPage from './pages/systemTools/page'
import RedisToolPage from './pages/systemTools/redis/page'
import EmailTestPage from './pages/systemTools/email/page'
import ClinicGroupsPage from './pages/clinicGroups/page'
import AdSupplierGroupsPage from './pages/adSupplierGroups/page'
import ClinicGroupPage from './pages/clinicGroup/page'
import ClinicGroupUsersPage from './pages/clinicGroup/users/page'
import ClinicGroupUserRolesPage from './pages/clinicGroup/userRoles/page'
import ClinicGroupClinicsPage from './pages/clinicGroup/clinics/page'
import AdSupplierGroupPage from './pages/adSupplierGroup/page'
import AdSupplierGroupUsersPage from './pages/adSupplierGroup/users/page'
import AdSupplierGroupUserRolesPage from './pages/adSupplierGroup/userRoles/page'
import AdSupplierGroupSuppliersPage from './pages/adSupplierGroup/suppliers/page'
import BannerConfigPage from './pages/bannerConfig/page'

export default function AppRoutes() {
  return (
    <Routes>
      {/* Demo page */}
      <Route path="/demo" element={<Layout />}>
        <Route index element={<Demo />} />
      </Route>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />

      {/* Protected routes with Layout */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />

        {/* Investor — independent route tree (not under /admin) */}
        <Route path="investor/clinics" element={<InvestorClinicsPage />} />

        {/* ========================================
            Admin (sys_admin global) subtree
           ======================================== */}
        <Route
          path="admin"
          element={
            <ScopedRoute scope="admin">
              <Outlet />
            </ScopedRoute>
          }
        >
          <Route index element={<AdminHomePage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="clinics" element={<ClinicsPage />} />
          <Route path="clinic/create" element={<ClinicPage />} />
          <Route path="user-roles" element={<UserRolesPage />} />
          <Route path="system-versions" element={<SystemVersionsPage />} />
          <Route path="ad-suppliers" element={<AdSuppliersPage />} />
          <Route path="ad-supplier/create" element={<AdSupplierPage />} />
          <Route path="integration-vendors" element={<IntegrationVendorsPage />} />
          <Route path="ad-schedule-templates" element={<AdScheduleTemplatePage />} />
          <Route path="ad-schedule-templates/:id" element={<ViewTemplatePage />} />
          <Route path="ad-schedule-templates/:id/edit" element={<EditTemplatePage />} />
          <Route path="ad-schedule-templates/:id/apply" element={<ApplyTemplatePage />} />
          <Route path="ad-image-batches" element={<AdImageBatchPage />} />
          <Route path="ad-image-batches/:id/edit" element={<EditAdImageBatchPage />} />
          <Route path="ad-image-batches/:id/apply" element={<ApplyAdImageBatchPage />} />
          <Route path="device-management" element={<DeviceManagementPage />} />
          <Route path="connection-status-snapshots" element={<ConnectionStatusSnapshotsPage />} />
          <Route path="audit-logs" element={<AuditLogsPage />} />
          <Route path="providers" element={<ProvidersPage />} />
          <Route path="provider/create" element={<ProviderPage />} />
          <Route path="apps/toolkit" element={<ToolkitPage />} />
          <Route path="apps/create-all-clinic-user-role" element={<CreateAllClinicUserRolePage />} />
          <Route path="apps/provider-clinic-users" element={<ProviderClinicUsersPage />} />
          <Route path="apps/announcements" element={<AnnouncementsPage />} />
          <Route path="apps/tv-templates" element={<TvTemplatesPage />} />
          <Route path="apps/tv-templates/:id" element={<TvTemplateDetailPage />} />
          <Route path="apps/tag-management" element={<TagManagementPage />} />
          <Route path="system-tools" element={<SystemToolsPage />} />
          <Route path="system-tools/redis" element={<RedisToolPage />} />
          <Route path="system-tools/email" element={<EmailTestPage />} />
          <Route path="clinic-groups" element={<ClinicGroupsPage />} />
          <Route path="ad-supplier-groups" element={<AdSupplierGroupsPage />} />
          <Route path="banner-config" element={<BannerConfigPage />} />
        </Route>

        {/* ========================================
            Provider scope subtree — reuses page components
           ======================================== */}
        <Route
          path="provider/:provider_id"
          element={
            <ScopedRoute scope="provider">
              <Outlet />
            </ScopedRoute>
          }
        >
          <Route index element={<ProviderPage />} />
          <Route path="info" element={<ProviderPage />} />
          <Route path="users" element={<ProviderUsersPage />} />
          <Route path="clinics" element={<ClinicsPage />} />
          <Route path="clinic/create" element={<ClinicPage />} />
          <Route path="ad-suppliers" element={<AdSuppliersPage />} />
          <Route path="ad-supplier/create" element={<AdSupplierPage />} />
          <Route path="clinic-groups" element={<ClinicGroupsPage />} />
          <Route path="ad-supplier-groups" element={<AdSupplierGroupsPage />} />
          <Route path="user-roles" element={<UserRolesPage />} />
          <Route path="ad-schedule-templates" element={<AdScheduleTemplatePage />} />
          <Route path="ad-schedule-templates/:id" element={<ViewTemplatePage />} />
          <Route path="ad-schedule-templates/:id/edit" element={<EditTemplatePage />} />
          <Route path="ad-schedule-templates/:id/apply" element={<ApplyTemplatePage />} />
          <Route path="ad-image-batches" element={<AdImageBatchPage />} />
          <Route path="ad-image-batches/:id/edit" element={<EditAdImageBatchPage />} />
          <Route path="ad-image-batches/:id/apply" element={<ApplyAdImageBatchPage />} />
          <Route path="banner-config" element={<BannerConfigPage />} />
          <Route path="device-management" element={<DeviceManagementPage />} />
          <Route path="connection-status-snapshots" element={<ConnectionStatusSnapshotsPage />} />
          <Route path="audit-logs" element={<AuditLogsPage />} />
          <Route path="apps/toolkit" element={<ToolkitPage />} />
          <Route
            path="apps/create-all-clinic-user-role"
            element={<CreateAllClinicUserRolePage />}
          />
          <Route path="apps/provider-clinic-users" element={<ProviderClinicUsersPage />} />
          <Route path="apps/announcements" element={<AnnouncementsPage />} />
          <Route path="apps/tv-templates" element={<TvTemplatesPage />} />
          <Route path="apps/tv-templates/:id" element={<TvTemplateDetailPage />} />
          <Route path="apps/tag-management" element={<TagManagementPage />} />
        </Route>

        {/* ========================================
            Clinic scope subtree
           ======================================== */}
        <Route
          path="clinic/:clinic_id"
          element={
            <ScopedRoute scope="clinic">
              <Outlet />
            </ScopedRoute>
          }
        >
          <Route index element={<ClinicHomePage />} />
          <Route path="info" element={<ClinicPage />} />
          <Route path="users" element={<ClinicUsers />} />
          <Route path="rooms" element={<ExaminationRoomsPage />} />
          <Route path="broadcast-devices" element={<BroadcastDevicesPage />} />
          <Route path="modules" element={<ModulesPage />} />
          <Route path="doctors" element={<DoctorsPage />} />
          <Route path="queue-machines" element={<QueueMachinesPage />} />
          <Route path="user-roles" element={<ClinicUserRolesPage />} />
        </Route>

        {/* ========================================
            Ad supplier scope subtree
           ======================================== */}
        <Route
          path="ad-supplier/:supplier_id"
          element={
            <ScopedRoute scope="ad_supplier">
              <Outlet />
            </ScopedRoute>
          }
        >
          <Route index element={<AdSupplierPage />} />
          <Route path="info" element={<AdSupplierPage />} />
          <Route path="users" element={<AdSupplierUsersPage />} />
          <Route path="ads" element={<AdSupplierAdsPage />} />
          <Route path="ad-images" element={<AdSupplierAdImagesPage />} />
          <Route path="brands" element={<AdSupplierBrandsPage />} />
          <Route path="ad-schedules" element={<SupplierAdSchedulesPage />} />
          <Route path="ad-schedules/:template_id" element={<SupplierAdScheduleViewPage />} />
          <Route path="clinics" element={<AdSupplierClinicsPage />} />
          <Route path="reports" element={<AdSupplierReportsPage />} />
          <Route path="user-roles" element={<SupplierUserRolesPage />} />
        </Route>

        {/* ========================================
            Clinic group scope subtree
           ======================================== */}
        <Route
          path="clinic-group/:clinic_group_id"
          element={
            <ScopedRoute scope="clinic_group">
              <Outlet />
            </ScopedRoute>
          }
        >
          <Route index element={<ClinicGroupPage />} />
          <Route path="info" element={<ClinicGroupPage />} />
          <Route path="users" element={<ClinicGroupUsersPage />} />
          <Route path="user-roles" element={<ClinicGroupUserRolesPage />} />
          <Route path="clinics" element={<ClinicGroupClinicsPage />} />
        </Route>

        {/* ========================================
            Ad supplier group scope subtree
           ======================================== */}
        <Route
          path="ad-supplier-group/:ad_supplier_group_id"
          element={
            <ScopedRoute scope="ad_supplier_group">
              <Outlet />
            </ScopedRoute>
          }
        >
          <Route index element={<AdSupplierGroupPage />} />
          <Route path="info" element={<AdSupplierGroupPage />} />
          <Route path="users" element={<AdSupplierGroupUsersPage />} />
          <Route path="user-roles" element={<AdSupplierGroupUserRolesPage />} />
          <Route path="suppliers" element={<AdSupplierGroupSuppliersPage />} />
        </Route>
      </Route>

      {/* Full screen protected routes without Layout */}
      <Route
        path="/war-room"
        element={
          <ProtectedRoute>
            <WarRoomPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/provider/:provider_id/war-room"
        element={
          <ProtectedRoute>
            <ScopedRoute scope="provider">
              <WarRoomPage />
            </ScopedRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/password"
        element={
          <ProtectedRoute>
            <ChangePassword />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/account"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />

      {/* Redirect any unknown routes to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
